import { ChangeDetectionStrategy, Component, forwardRef, input, output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ZardInputDirective } from '../../../app/shared/components/input/input.directive';
import { SvzControl } from '../svz-control';

@Component({
  selector: 'svz-text-area',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './svz-text-area.component.html',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SvzTextAreaComponent), multi: true }],
  standalone: true,
  imports: [ZardInputDirective],
})
export class SvzTextAreaComponent extends SvzControl {
  readonly label = input<unknown>(undefined);

  readonly icon = input('');

  readonly readonly = input<boolean>(false);

  readonly autosize = input<boolean>(true);

  readonly minRows = input<number>(1);

  readonly maxRows = input<number>(10);

  readonly placeholder = input('');

  readonly charCount = input<boolean>(false);

  readonly maxLength = input(0);

  readonly inputId = input('');

  readonly fallbackTextValue = input('');

  readonly autoFocus = input<boolean>(undefined);

  readonly tooltip = input('');

  readonly ngModelChange = output<unknown>();

  readonly blur = output<void>();

  get labelText(): string {
    const label = this.label();
    return typeof label === 'string' ? label : ((label as { text?: string } | null)?.text ?? '');
  }

  get displayValue(): string {
    if (typeof this.value === 'string') {
      return this.value;
    }

    return this.fallbackTextValue() ?? '';
  }

  get resolvedRows(): number {
    return this.autosize() ? this.minRows() : Math.max(this.minRows(), this.maxRows());
  }

  handleInput(event: Event): void {
    const nextValue = (event.target as HTMLTextAreaElement | null)?.value ?? '';
    this.value = nextValue;
    this.control.setValue(nextValue, { emitEvent: false });
    this.onChange(nextValue);
    this.ngModelChange.emit(nextValue);
  }

  handleBlur(): void {
    this.onTouched();
    this.blur.emit();
  }

  protected override onValueChanged(value: unknown): void {
    this.ngModelChange.emit(value);
  }
}
